import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { metaTitle } from '../../../util/tabTitle';
import AuthShell from '../AuthShell';

const SignUpPage: FC = () => {
  metaTitle('Sign Up');
  return (
    <AuthShell
      title="Create an account"
      subtitle="Accounts are managed securely by your organization administrator."
    >
      <Stack spacing={2}>
        <Typography color="text.secondary" textAlign="center">
          Ask your administrator to invite you or create an account for your
          organization.
        </Typography>
        <Button
          component={RouterLink}
          to="/sign-in"
          variant="contained"
          sx={{ minHeight: 42 }}
        >
          Back to sign in
        </Button>
      </Stack>
    </AuthShell>
  );
};

export default SignUpPage;
